export default __webpack_public_path__ + "static/media/BeginningJournal_Dark2.1eded93c.svg";